// Home.vue

<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-img :src="require('../../../assets/CGRwebapp_logo.png')" class="my-3" contain height="200" />
      </v-col>
    </v-row>
    <v-row class="text-center">
<!--       <v-col cols="12">
        <h1 >Bonjour {{$root.user.prenom}} {{$root.user.nom}}</h1>
      </v-col> -->
      
    </v-row>
    <v-row class="text-center">
      <v-col cols="12">
        <h2 ><v-badge v-bind:content="version" color="primary">Bienvenue sur CGR Webapp</v-badge></h2>
      </v-col>
    </v-row>
    <br/><br/>
    <v-col cols="12">
      <v-row justify="center">
        <v-col cols="6" sm="12" md="6" v-if="$root.user.role=='COM'">
          <v-card color="deep-purple darken-1" dark min-height="140" shaped to="/souscription/choixcategorieoffre">
            <v-card-title class="headline">Nouvelle souscription</v-card-title>
            <v-card-subtitle>Souscrire à une offre sur un nouveau contrat ou un contrat existant</v-card-subtitle>
          </v-card>
   
        </v-col>
        <v-col cols="6" sm="12" md="6" v-if="$root.user.role=='ITINERANT'">
          <v-card color="deep-purple darken-1" dark min-height="140" shaped to="/souscription/choixcategorieoffre">
            <v-card-title class="headline">Nouvelle souscription</v-card-title>
            <v-card-subtitle>Souscrire à une offre sur un nouveau contrat ou un contrat existant</v-card-subtitle>
          </v-card>
   
        </v-col>
        <v-col cols="6" sm="12" md="6" v-if="$root.user.role=='COMPRO'">
          <v-card :color="eligColor" dark min-height="140" shaped to="/souscription/offresbox/eligibilite/adresse">
            <v-card-title class="headline">Eligibilité</v-card-title>
            <v-card-subtitle>Tester l'éligibilité à partir de l'adresse ou de la localisation géographique</v-card-subtitle>
          </v-card>
   
        </v-col>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
import {AppService} from '../../../providers/AppService.js';
const appService = new AppService();
export default {
  name:'ComHome',
  data: () => ({
      eligColor: 'secondary',
      version: null
  }),
  mounted:function(){
    //this.$root.initSouscription();
    this.version = appService.APP_VERSION;
    if(this.$root.user.univers != 'com')
      this.$root.logout(); 
  }

};
</script>